import React from "react";
import { Helmet } from "react-helmet";
import HeroSection from "./HeroSection";
import VisionMissionSection from "./VisionMissionSection";
import OfferingsSection from "./OfferingsSection";
import WhyChooseUsSection from "./WhyChooseUsSection";
import CallToActionSection from "./CallToActionSection";
import Footer from "../../component/common/Footer";
import FounderTestimonial from "./FounderTestimonial";
import ImpactSection from "./ImpactSection";

const AboutPage = () => {
  return (
    <>
      <Helmet>
        <title>
          Sustainable Energy & Organic Agriculture Solutions | Govardhannathji
          Energies LLP
        </title>
        <meta
          name="description"
          content="Leading provider of eco-friendly biogas energy solutions and organic fertilizers. Join our green initiative for sustainable agriculture and renewable energy. Expert solutions since inception."
        />
        <meta
          property="og:title"
          content="Sustainable Energy & Organic Agriculture Solutions | Govardhannathji Energies LLP"
        />
        <meta
          property="og:description"
          content="Leading provider of eco-friendly biogas energy solutions and organic fertilizers. Join our green initiative for sustainable agriculture and renewable energy. Expert solutions since inception."
        />
      </Helmet>

      <main>
        <HeroSection />
        <VisionMissionSection />
        <FounderTestimonial />
        <OfferingsSection />
        <ImpactSection />
        <WhyChooseUsSection />
        <CallToActionSection />
        <Footer />
      </main>
    </>
  );
};

export default AboutPage;
